// This file is auto generated using CMS based event tracking.
// Do not modify this file manually!
import { BaseTrackingContext } from '@goeuro/app/client/tracking-provider/src/cms/lib/BaseTrackingContext';

/* Properties block */
export type SearchPassengerContextProperties = {
  age_bracket_max?: number;
  type: string;
  age?: number;
  age_bracket_min?: number;
  id: string;
  discount_cards: string[];
};

/* Context definition block */
const schema = 'iglu:com.goeuro/search_passenger_context/jsonschema/2-0-0';
export const searchPassengerContextName = 'search_passenger_context';
export class SearchPassengerContext extends BaseTrackingContext<SearchPassengerContextProperties> {
  constructor(properties: SearchPassengerContextProperties) {
    super(searchPassengerContextName, schema, properties);
  }
}
